import 'react-app-polyfill/ie11'; // REQUIRED for IE11 polyfills
import 'react-app-polyfill/stable'; // REQUIRED for all other polyfills
import React from 'react';
import ReactDOM from 'react-dom';
import config from './config';
import { AuthenticationProvider, HttpErrorPage, LoadingStatus, SessionTimeout } from '@paycor/pacl';
import * as serviceWorker from './serviceWorker';
import I18nWrapper from 'utils/I18nWrapper';
import './index.css';
import App from 'App/App';

const {
	APIM_SUBSCRIPTION_KEY,
	HOST: { HCM_BASE_DOMAIN_URL },
	securitySettings
} = config;

let authConfig = {
	authority_url: securitySettings.authority, // The URL of the OIDC/OAuth2 provider (ex: https://developerapi-dev.paycor.com/sts/v1/common)
	callback_url: securitySettings.redirect_uri, // The URL for your application's sign-in callpack page (ex: http://tfs.paycor.com:8080/tfs/Paycor/Paycor%20Inc/A-Team/_git/SecurityExampleApps?path=%2FStsExamples%2FReactApp%2Fapp%2Fstatic%2Fcallback.html)
	client_id: securitySettings.client_id, // Application OAuth client ID
	scope: securitySettings.scope, // The scope (name) being requested
	APIm: APIM_SUBSCRIPTION_KEY // Your application's APIm key
};

ReactDOM.render(
	<React.Suspense fallback={<LoadingStatus />}>
		<AuthenticationProvider settings={authConfig}>
			<HttpErrorPage>
				<SessionTimeout applicationUrl={HCM_BASE_DOMAIN_URL} refreshUrl={`${HCM_BASE_DOMAIN_URL}/accounts/`} APIm={APIM_SUBSCRIPTION_KEY}>
					<I18nWrapper>
						<App />
					</I18nWrapper>
				</SessionTimeout>
			</HttpErrorPage>
		</AuthenticationProvider>
	</React.Suspense>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
